/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MyUserInfo {
  guid: string;
  userimg: string;
  nickname: string;
  cover_id: string;
  decoration_id: string;
  vip_level: number;
  lev: number;
  title_1: string;
  gender: string;
  profession: string;
  introduction: string;
  follow_num: number;
  fans_num: number;
  follow_status: number;
  share_url: string;
  medals: {
    type?: string;
    status?: number;
    img?: string;
    img_black?: string;
  }[];
  jump_url_levels: string;
  jump_url_medals: string;
}

export interface MyTalkList {
  /** 标题 */
  title: string;
  documentId: string;
  /** 类型 */
  type: string;
  /** 房间id */
  id: string;
  /** 图片 */
  thumbnail: string;
  /** 样式 */
  style: {
    view: string;
  };
  /** 统计id */
  staticId: string;
  /** 播客节目简介 */
  intro: string;
  /** 创建时间（播客） */
  create_time?: string;
  /** 播放数（播客） */
  playNum?: string;
  /** 评论数（播客） */
  commentsCount?: string;
  /** 房间信息（直播） */
  studioInfo?: {
    /** 状态 */
    status: number;
    /** 状态文案 */
    statusText: string;
    /** 时间显示文案 */
    dateText: string;
    /** 预约id */
    subId: string;
    id: string;
    /** 嘉宾名称 */
    honouredGuest: string;
  };
  /** 音频信息（播客） */
  audioInfo?: {
    /** 音频时长 */
    duration: number;
    /** 音频播放地址 */
    mp3: string;
    link: {
      type: string;
      url: string;
    };
  };
  /** 跳转链接 */
  link: {
    type?: string;
    url?: string;
  };
  reviewType: string;
}

export interface MyTalk {
  items?: MyTalkList[];
  page: number;
  totalPage: number;
  total: number;
  pageSize: number;
}

export interface MyComment {
  guid: number;
  type: number;
  comment_id: string;
  comment_contents: string;
  add_time: string;
  createTime: string;
  title: string;
  thumbnail: string;
  docId: string;
  commentsUrl: string;
  duration: string;
  link: {
    type: string;
    url: string;
    weburl: string;
  };
  like: number;
  share_url: string;
  raw_doc_id: string;
  doc_status: number;
  share_id: string | null;
  pics: {
    url: string;
    width: string;
    height: string;
  }[];
}

export interface MyList {
  msg_status: string;
  userinfo: MyUserInfo;
  feeds: {
    total_page: number;
    current_page: number;
    limit: number;
    list: MyComment[];
  };
}

export interface PersonalInfo {
  userinfo: {
    guid: string;
    userimg: string;
    nickname: string;
    followid: string;
    label: {
      name: string;
      url: string;
    }[];
    bgimg: string;
    bgimg_audit_status: boolean;
    level_title: string;
    introduction: string;
    follow_num: number;
    fans_num: number;
    post_num: number;
    follow_status: number;
    share_url: string;
    jump_url_levels: string;
    userLocation: string;
    liked_num: number;
    liked_status: number;
    new_medal: {
      medalPicId: string;
      medalId: string;
    };
    register_time: string;
  };
  studio_info: {
    room_status: number;
    link: {
      type: string;
      url: string;
    };
  };
  privacy_setting: {
    close_fans_list: number;
    close_follow_list: number;
  };
  nav: {
    tag: string;
    name: string;
    sub_nav: {
      tag: string;
      name: string;
      url: string;
    }[];
  }[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title 天下事个人页
 * @version 1.0.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  socialApiFeeds = {
    /**
     * @description |说明|地址| |---|---| |此接口测试域名|test.user.iclient.ifeng.com 修改hosts 10.66.224.181| |此接口正式域名|https://uc.iclient.ifeng.com| |||
     *
     * @tags 个人页2.0
     * @name PersonalInfoList
     * @summary 我的主页2.0
     * @request GET:/social_api_feeds/personalInfo
     */
    personalInfoList: (
      query?: {
        /**
         * 当前用户id
         * @example "4000000028810640624"
         */
        loginid?: string;
        /**
         * 版本
         * @example "7.50.0"
         */
        gv?: string;
        /**
         * 客户端类型
         * @example ""
         */
        proid?: string;
        /**
         * 设备号
         * @example ""
         */
        deviceid?: string;
        /**
         * 登陆令牌
         * @example ""
         */
        token?: string;
        /**
         * 系统
         * @example ""
         */
        os?: string;
        /**
         * 客态用户的guid
         * @example "4000000028810640624"
         */
        guid_feeds?: string;
        /**
         * 分享页加密token
         * @example ""
         */
        share_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          code: number;
          msg: string;
          data: PersonalInfo;
        },
        any
      >({
        path: `/social_api_feeds/personalInfo`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description |说明|地址| |---|---| |此接口测试域名|[www.Tongtest7.com](http://www.Tongtest7.com) 修改hosts 10.21.6.102| |此接口正式域名|https://uc.iclient.ifeng.com| |||
     *
     * @tags 个人页
     * @name MyListList
     * @summary 我的主页(私信状态)
     * @request GET:/social_api_feeds/myList
     */
    myListList: (
      query: {
        /** 当前用户id */
        guid?: string;
        /**
         * 版本
         * @example ""
         */
        gv?: string;
        /**
         * 客户端类型
         * @example ""
         */
        proid?: string;
        /**
         * 设备号
         * @example ""
         */
        deviceid?: string;
        /**
         * 登陆令牌
         * @example ""
         */
        token?: string;
        /**
         * 系统
         * @example ""
         */
        os?: string;
        /**
         * 第几页
         * @example ""
         */
        page: string;
        /**
         * 每页多少条
         * @example ""
         */
        limit: string;
        /**
         * 显示用户主页的用户id
         * @example ""
         */
        guid_feeds: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          code: number;
          msg: string;
          data: MyList;
        },
        any
      >({
        path: `/social_api_feeds/myList`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  apiGuest = {
    /**
     * No description
     *
     * @tags 嘉宾-前台
     * @name GetRoomListByGuidList
     * @summary 嘉宾id获取房间列表（天下事）
     * @request GET:/api_guest/getRoomListByGuid
     */
    getRoomListByGuidList: (
      query: {
        /**
         * 用户id
         * @example "4000000089718118738"
         */
        guid: string;
        /**
         * living-直播，podcast-播客
         * @example "living"
         */
        limitType: string;
        /**
         * 页码
         * @example "1"
         */
        page: string;
        /**
         * 每页条数
         * @example "10"
         */
        pageSize?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          code?: number;
          msg?: string;
          data?: MyTalk;
        },
        any
      >({
        path: `/api_guest/getRoomListByGuid`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  indexPhp = {
    /**
     * @description 接口示例：[http://local.sv.ifeng.com/](http://local.sv.ifeng.com/)[index.php/survey/postsurvey?id=9999&sur\\[19967\\]\\[\\]=77660&sur\\[19968\\]\\[\\]=77665&sur\\[19969\\]\\[\\]=77666&sur\\[19970\\]\\[\\]=77668&ref=http://survey.ifeng.com/talk/9999.html](http://index.php/survey/postsurvey?id=9999&sur%5B19967%5D%5B%5D=77660&sur%5B19968%5D%5B%5D=77665&sur%5B19969%5D%5B%5D=77666&sur%5B19970%5D%5B%5D=77668&ref=http://survey.ifeng.com/talk/9999.html) <span lang="EN-US"></span>
     *
     * @tags 投票调查项目/公共分类
     * @name SurveyPostsurveyList
     * @summary 投票提交接口
     * @request GET:/index.php/survey/postsurvey
     */
    surveyPostsurveyList: (
      query: {
        /**
         * 提交记录的ID值
         * @example "6990872095144026112"
         */
        id: string;
        /**
         * sur[25553][]=99846，其中25553为问题id,99846为选项id；多个sur用&连接
         * @example "sur[25553][]=99846"
         */
        sur: string;
        /**
         * 来源页面
         * @example ""
         */
        ref: string;
        /**
         * 唯一标识,uid或设备ID,仅限 客户端限制 使用
         * @example ""
         */
        myid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          ifsuccess: number;
          msg: string;
        },
        any
      >({
        path: `/index.php/survey/postsurvey`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description "ifsuccess": 1, //<span class="colour" style="color:black">是否成功  1成功 0失败</span> "msg": "ok",   //<span class="colour" style="color:black">返回的提示信息 ok代表成功</span> "data": { "surveyinfo": { "id": "16004",   //投票id "leadtxt": "测试2",   //投票简介 "starttime": "1577692002",   //投票开始时间 "createby": "",  //目前没用到 "email": "wangfang",   //投票创建邮箱 "user": "王芳",   //投票创建人 "pnum": 3,   //参与人数 "votecount": 3,  //总投票数 "status": "0",  //上下线状态，0：下线，1：上线 "is_vote": "0",  //是否为投票 0:调查，1:投票 "channelid": "1-",   //频道id "channelname": "财经",  //频道名称 "channelename": "finance"  //频道名称 "channelurl": "[http://finance.ifeng.com/](http://finance.ifeng.com/)",  //频道页面地址 "channellogourl": "[http://y2\.ifengimg\.com/a/2015/0715/logo\_finance\_z\.gif](http://y2.ifengimg.com/a/2015/0715/logo_finance_z.gif)",  //频道logo地址 "searchPath": "",  //目前没用到 "id62": "4A8",  //投票id "url": "",  //目前没用到 "endtime": "2020-01-29 00:00:00", //结束时间 "expire": "0",  //是否过期 1:没过期，0:过期 "createtime": "2019-12-30 15:46:42",  //创建时间 "currenttime": "2022-07-27 16:38:26",  //当前时间 "title": "测试2",  //标题 "isactive": "0",  //同status 上下线状态，0：下线，1：上线 "skey": "e64d10",  //目前没用到 "questionids": [ "32504"  //问题id ], "is_voted": "0"   //是否有人投票 ，0:无，1:有 }, "surveysetting": { "surid": "16004",  //投票id "period": "1580227200",   //投票过期时间 "expinfo": "抱歉,本调查已经结束",   //投票过期提示语 "weight": "1",  //投票权重 "tags": null,  //目前没用到 "titlelink": "",  //标题链接 "iswarn": "0",  //风险控制 "ishidden": "0",  //显示限制 "limitstatus": "1",  //是否限制刷票 （0不限制 1cookie限制 2ip限制 3登陆限制） "limittime": "0.5",  **<span class="colour" style="color:rgb(0, 176, 80)">//限制间隔时间 为小时数</span>** "limitnum": "1",  **<span class="colour" style="color:rgb(0, 176, 80)">//限制间隔时间内所能投的最大票数</span>** "ticknum": null,  //目前没用到 "userstatus": "0",  //目前没用到 "userinfo": null,  //目前没用到 "isshow": "1",   //查看结果 "iscomment": "1",   //是否开启评论，0:不开启，1:开启 "finishinfo": "投票成功，感谢您的参与！",   //投票成功的提示语 "isjump": "0",   //是否跳转 0:否，1:是 "jumplink": "",  //跳转链接 "h5": "3",  //目前没用到 "liststyle": "0",  **<span class="colour" style="color:red">// 0为正常 1为只展示第一个标题</span>** "id62": "4A8"  //id }, "count": 3, "result": [ { "resultArray": { "option": [ { "title": "选项1",  //选项标题 "itemid": "127149",   //选项id "num": 1,  //投票数 "pic_url": "",  //目前没用到 "url": "",  //目前没用到 "is_both": "1",  //目前没用到 "nump": 33.33  //投票比例 }, { "title": "选项2", "itemid": "127150", "num": 2, "pic_url": "", "url": "", "is_both": "1", "nump": 66.67 } ], "questionid": "32504",  //问题id "votecount": 3,   //投票数 "question": "问题1",  //问题描述 "choosetype": "single",  //单选还是多选，单选：single，多选：multiple "ismust": "1". //是否必选 必选：1，可选：0 } } ], 用户投票信息字段注释： "userVoteInfo": { "guid": { "问题id1": ["选项id1", "选项id2"], "问题id2": ["选项id3"] } } 线上地址：[http://local.sv.ifeng.com/index.php/survey/getdata?id=16004](http://local.sv.ifeng.com/index.php/survey/getdata?id=16004)
     *
     * @tags 投票调查项目/公共分类
     * @name SurveyGetdataList
     * @summary 详情接口
     * @request GET:/index.php/survey/getdata
     */
    surveyGetdataList: (
      query: {
        /**
         * 查询记录的ID值,多条英文逗号分隔,若id=1则为单题请求，id=1,2,3为查询多条数据
         * @example "1"
         */
        id: string;
        /** @example "1" */
        isUserSurveyInfo?: string;
        /** @example "1111111" */
        guid?: string;
        /**
         * 返回数组（如果不传此参数，获取单条id和多条id数据结构不一样）
         * @example "1"
         */
        isArr?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          ifsuccess: number;
          msg: string;
          data: {
            surveyinfo: {
              id: string;
              leadtxt: string;
              starttime: string;
              createby: string;
              email: string;
              user: string;
              pnum: number;
              votecount: number;
              status: string;
              is_vote: string;
              channelid: string;
              channelname: string;
              channelename: string;
              channelurl: string;
              channellogourl: string;
              searchPath: string;
              id62: string;
              url: string;
              endtime: string;
              expire: string;
              createtime: string;
              currenttime: string;
              title: string;
              isactive: string;
              skey: string;
              questionids: string[];
              is_voted: string;
            };
            surveysetting: {
              surid: string;
              period: string;
              expinfo: string;
              weight: string;
              tags: null;
              titlelink: string;
              iswarn: string;
              ishidden: string;
              limitstatus: string;
              limittime: string;
              limitnum: string;
              ticknum: null;
              userstatus: string;
              userinfo: null;
              isshow: string;
              iscomment: string;
              finishinfo: string;
              isjump: string;
              jumplink: string;
              h5: string;
              liststyle: string;
              id62: string;
            };
            count: number;
            result: {
              resultArray?: {
                option: {
                  title: string;
                  itemid: string;
                  num: number;
                  pic_url: string;
                  url: string;
                  is_both: string;
                  nump: number;
                }[];
                questionid: string;
                votecount: number;
                question: string;
                choosetype: string;
                ismust: string;
              };
            }[];
            userSurveyInfo: {
              "11111": {
                "32503": string[];
                "32504": string[];
              };
            };
          };
        },
        any
      >({
        path: `/index.php/survey/getdata`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
